import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function OurAchivements() {

    const feed = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]


    return (
        <>
            <div className="mt-16 w-full text-5xl font-bold text-right text-zinc-900 max-md:mt-10 max-md:max-w-full">
                إنجازتنا حول العالم
            </div>
            <div className="mt-8 w-full max-md:max-w-full">
                <div className="grid grid-cols-4 gap-5 max-w-full max-md:grid-cols-1 max-md:max-w-full">
                    {feed.filter((item, index) => index < 8).map((filteredItem, index) => (

                        <div className="flex flex-col max-md:ml-0 max-md:w-full">
                            <div className="flex flex-col grow p-2 w-full text-right bg-white rounded-lg border border-solid border-zinc-300 text-stone-900 max-md:mt-5">
                                <LazyLoadImage
                                    loading="lazy"
                                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/1c3d6e6d79d8523b4f5e76b08bc55d2f6e75930be94985eecf9d37cd2497e25b?apiKey=1b00d6cd98374704a0468862af744bdf&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/1c3d6e6d79d8523b4f5e76b08bc55d2f6e75930be94985eecf9d37cd2497e25b?apiKey=1b00d6cd98374704a0468862af744bdf&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/1c3d6e6d79d8523b4f5e76b08bc55d2f6e75930be94985eecf9d37cd2497e25b?apiKey=1b00d6cd98374704a0468862af744bdf&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/1c3d6e6d79d8523b4f5e76b08bc55d2f6e75930be94985eecf9d37cd2497e25b?apiKey=1b00d6cd98374704a0468862af744bdf&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/1c3d6e6d79d8523b4f5e76b08bc55d2f6e75930be94985eecf9d37cd2497e25b?apiKey=1b00d6cd98374704a0468862af744bdf&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/1c3d6e6d79d8523b4f5e76b08bc55d2f6e75930be94985eecf9d37cd2497e25b?apiKey=1b00d6cd98374704a0468862af744bdf&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/1c3d6e6d79d8523b4f5e76b08bc55d2f6e75930be94985eecf9d37cd2497e25b?apiKey=1b00d6cd98374704a0468862af744bdf&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/1c3d6e6d79d8523b4f5e76b08bc55d2f6e75930be94985eecf9d37cd2497e25b?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                    className="w-full rounded-md aspect-[1.35]"
                                />
                                <div className="flex flex-col p-2 mt-1">
                                    <div className="flex gap-2.5 justify-between text-xl font-bold whitespace-nowrap text-zinc-900">
                                        <LazyLoadImage
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/dcdd841e833ffb5d2e5caf2ca6f4d8e8a3f3e847fa2ad2eee9abc1a981d98fb7?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                            className="my-auto w-8 aspect-[1.33]"
                                        />
                                        <div className="grow">اليمن</div>
                                    </div>
                                    <div className="flex gap-5 justify-between mt-3 whitespace-nowrap">
                                        <div className="text-sm">مشاريع</div>
                                        <div className="text-sm">4,500</div>
                                    </div>
                                    <div className="flex gap-5 justify-between mt-3 whitespace-nowrap">
                                        <div className="text-sm">كفالات</div>
                                        <div className="text-sm">43,480</div>
                                    </div>
                                    <div className="flex gap-5 justify-between mt-3">
                                        <div className="text-sm">مساعدات غذائية</div>
                                        <div className="text-sm">450,000</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default OurAchivements